import {ProductDetails} from './product-details';
import {Utils} from '../utils/utils';
import {Ajax} from '../utils/ajax';
import {ToastMessage} from './toast-message';

export class ModelInfoModal {

  constructor(root) {
    this.root = root;
    this.contentSlot = this.root.querySelector('[slot="content"]');
  }

  loadModel(model) {
    Utils.toggleFullScreenProgress(true);
    Ajax.loadModelInfo(model, (err, data) => {
      Utils.toggleFullScreenProgress(false);
      if (err || !data || !data.success) {
        console.error(err);
        ToastMessage.show({
          message: 'Could not load the model information.',
          type: 'alert'
        });
        return;
      }

      this.updateModelInfo(data.data.html);
      this.root.openModal();
    });
  }

  updateModelInfo(html) {
    this.contentSlot.innerHTML = html;
    this.detailsRoot = this.contentSlot.querySelector('.product__details');
    this.productDetails = new ProductDetails(this.detailsRoot);
  }

  closeModal() {
    this.root.closeModal();
  }
}